<!--
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-06-19 15:45:39
 * @LastEditors: 陈钊贤
 * @Description: 
 * @LastEditTime: 2020-12-23 09:55:14
--> 
<template>
  <pi-content class="pi-enterprise-member">
    <pi-enterprise-text>{{entData.entName}}</pi-enterprise-text>
    <section class="member-info">
      <pi-card title="企业账户">
        <!-- <pi-button type="primary"
                   size="mini"
                   slot="header-right"
                   @click="goRecharge">充值</pi-button> -->
        <div class="acc-info">
          <div class="info-item"
               v-for="(item,index) in tabList"
               :key="index">
            <div class="number">{{item.value  | formatNullValue}}</div>
            <div class="text">{{item.name}}</div>
          </div>
        </div>
      </pi-card>
      <pi-order-tab :accountPkId="entData.entUserPkId"
                    :data="entData.payOrderStat || {}"
                    title="充电订单(企业支付)"
                    userType="4"></pi-order-tab>
      <pi-order-tab :accountPkId="entData.entUserPkId"
                    :data="entData.nonpayOrderStat || {}"
                    title="充电订单(个人支付)"
                    userType="5"></pi-order-tab>
      <div class="invoice-box" @click="invoiceClick">
        <div>
          <img class="invoice-icon" src="../../assets/img/invoice-icon.png" alt="">
        </div>
        <div class="invoice-flex">发票管理</div>
      </div>
      <div class="btn-box">
        <pi-button type="primary" block @click="goRecharge">充值</pi-button>
      </div>
    </section>
  </pi-content>
</template>
<script>
import Card from "@/components/pi-card/pi-card";
import OrderTab from "../my/components/pi-order-tab";
import enterpriseText from "@/components/pi-enterprise-text/pi-enterprise-text";
import { getEntOverview } from "@/common/api";
export default {
  name: "pi-enterprise-member",
  components: {
    [Card.name]: Card,
    [OrderTab.name]: OrderTab,
    [enterpriseText.name]: enterpriseText
  },
  data() {
    return {
      tabList: [
        { value: 10, name: "总成员(人)" },
        { value: 10, name: "支付成员(人)" },
        { value: 10, name: "非支付成员(人)" },
        { value: 10, name: "账户余额(元)" },
        { value: 10, name: "本月电量(度)" }
      ],
      entUserPkId: "",
      entData: {}
    };
  },
  methods: {
    goRecharge() {
      this.$router.push("/recharge?userType=3");
    },
    getEntOverview() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: "加载中..."
      });
      getEntOverview({ entUserPkId: this.entUserPkId })
        .then(ret => {
          if (ret.status === 0 && ret.data[0]) {
            this.entData = ret.data[0];
            this.tabList = [
              { value: this.entData.memberCount, name: "总成员(人)" },
              { value: this.entData.payMemberCount, name: "支付成员(人)" },
              { value: this.entData.nonpayMemberCount, name: "非支付成员(人)" },
              { value: this.entData.balanceAmount, name: "账户余额(元)" },
              { value: this.entData.elecOfCurrMonth, name: "本月电量(度)" }
            ];
          }
          this.$toast.clear();
        })
        .catch(() => {
          this.$toast.clear();
        });
    },
    invoiceClick(){
      this.$router.push({
        name: "my-invoice",
        query:{
          type: '1'
        }
      });
    }
  },
  mounted() {
    this.$common.bodyAddBg();
    this.entUserPkId = this.$route.query.entUserPkId;
    this.getEntOverview();
  },
  destroyed() {
    this.$common.removeBodyBg();
  }
};
</script>
<style lang="less">
.pi-enterprise-member {
  .top-text {
    background: rgba(255, 210, 152, 0.25);
    padding: 0.08rem 0;
    color: #666666;
    font-size: 0.24rem;
    line-height: 0.33rem;
    text-align: center;
  }
  .member-info {
    padding: 0.2rem;
  }
  .acc-info {
    display: flex;
    flex-wrap: wrap;
    padding-top: 0.3rem;
    color: #666;
    .info-item {
      width: 33.33%;
      text-align: center;
      margin-bottom: 0.3rem;
      .number {
        font-size: 0.38rem;
        line-height: 0.53rem;
      }
      .text {
        margin-top: 0.1rem;
        font-size: 0.26rem;
        line-height: 0.37rem;
      }
    }
  }
  .invoice-box{
    margin-top: 0.2rem;
    background-color: #fff;
    border-radius: 0.12rem;
    display: flex;
    padding: 0.2rem;
  }
  .invoice-icon{
    width:0.54rem;
    height:0.54rem;
    vertical-align: top;
  }
  .invoice-flex{
    flex: 1;
    line-height: 0.54rem;
    padding-left: 0.2rem;
    font-size: 0.3rem;
    color: #333;
  }
  .btn-box{
    padding: 0 0.2rem;
    margin-top: 0.54rem;
  }
}
</style>